import { useState, useEffect } from "react";

// Resolve the viewer's timezone + city from their location/locale.
const TZ = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
const CITY = TZ.split("/").pop().replace(/_/g, " ");
function tzAbbr(d) {
  try {
    const p = new Intl.DateTimeFormat("en-US", { timeZoneName: "short", hour: "2-digit" }).formatToParts(d);
    return p.find((x) => x.type === "timeZoneName")?.value || "";
  } catch { return ""; }
}

export function Clock({ mode = "digital", stacked = false }) {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);

  const time = now.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
  const date = now.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
  const abbr = tzAbbr(now);

  if (mode === "analog") {
    const s = now.getSeconds(), mi = now.getMinutes(), h = now.getHours() % 12;
    const secA = s * 6, minA = mi * 6 + s * 0.1, hA = h * 30 + mi * 0.5;
    const hand = (angle, len, w, color) => {
      const rad = (angle - 90) * (Math.PI / 180);
      return <line x1="18" y1="18" x2={18 + len * Math.cos(rad)} y2={18 + len * Math.sin(rad)} stroke={color} strokeWidth={w} strokeLinecap="round" />;
    };
    return (
      <div className="flex items-center gap-2" data-testid="os-clock" title={`${CITY} · ${abbr}`}>
        <svg width="36" height="36" viewBox="0 0 36 36" className="shrink-0">
          <circle cx="18" cy="18" r="16" fill="hsl(var(--card))" stroke="currentColor" strokeOpacity="0.35" strokeWidth="1.5" />
          {[...Array(12)].map((_, i) => {
            const a = (i * 30 - 90) * (Math.PI / 180);
            return <circle key={i} cx={18 + 13 * Math.cos(a)} cy={18 + 13 * Math.sin(a)} r={i % 3 === 0 ? 0.9 : 0.5} fill="currentColor" fillOpacity="0.55" />;
          })}
          {hand(hA, 7.5, 1.8, "currentColor")}
          {hand(minA, 11, 1.4, "currentColor")}
          {hand(secA, 12, 0.7, "#B8962E")}
          <circle cx="18" cy="18" r="1.3" fill="#B8962E" />
        </svg>
        <span className="hidden lg:flex flex-col leading-tight mono text-[10px] text-muted-foreground"><span className="text-foreground/80 font-medium">{CITY}</span><span>{abbr}</span></span>
      </div>
    );
  }

  if (stacked) {
    return (
      <span className="hidden md:flex flex-col items-end leading-tight mono text-[11px] text-muted-foreground px-1" data-testid="os-clock" title={`${CITY} · ${abbr}`}>
        <span className="text-foreground/80">{time}</span><span>{date} · {CITY}</span>
      </span>
    );
  }
  return (
    <span className="hidden md:inline text-xs mono text-muted-foreground mr-1" data-testid="os-clock" title={TZ}>
      {date} · {time} · <span className="text-foreground/70">{CITY} {abbr && `(${abbr})`}</span>
    </span>
  );
}
